import QuestionPoolEditor from "pages/ManagementPage/questionSection/QuestionPoolEditor/QuestionPoolEditor";

export default QuestionPoolEditor;
